export function getHtmlElement() {
  return document.documentElement
}
